import { Box, SxProps } from '@mui/material';
import { Tag } from '@sweep-io/sweep-design';
import { ZOOM_TRANSFORM_CLASSES } from '../getZoomTransformStyle';

export const TopTag = ({ topTag, sx }: { topTag: string; sx?: SxProps }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: -32,
        left: 0,
        ...sx,
        transformOrigin: 'bottom left',
      }}
      className={ZOOM_TRANSFORM_CLASSES.TARGET}
    >
      <Tag label={topTag} size="medium" textTheme="dark" color="#F3F4F5" />
    </Box>
  );
};
